import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken } from "@/lib/api";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@invoiceapp.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success("Welcome back");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-between p-12 bg-zinc-900 text-zinc-100">
        <div className="font-display text-2xl tracking-tight" data-testid="brand-logo">
          Invoice<span className="text-zinc-400">.</span>App
        </div>
        <div className="space-y-6 max-w-md">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
            For independent makers
          </p>
          <h1 className="font-display text-5xl font-light leading-tight">
            Invoices that feel like they were sent by a designer.
          </h1>
          <p className="text-zinc-400 leading-relaxed">
            Draft a bill, share a link, get paid. No fluff.
          </p>
        </div>
        <p className="text-xs text-zinc-500">© 2026 InvoiceApp</p>
      </div>

      {/* Right form panel */}
      <div className="flex items-center justify-center p-8 bg-white">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-md space-y-10"
          data-testid="login-form"
        >
          <div className="space-y-2">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
              Admin Sign In
            </p>
            <h2 className="font-display text-3xl font-medium tracking-tight text-zinc-900">
              Welcome back.
            </h2>
            <p className="text-zinc-500 text-sm">
              Demo credentials are pre-filled.
            </p>
          </div>

          <div className="space-y-6">
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
                Email
              </label>
              <input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border-0 border-b border-zinc-200 rounded-none px-0 py-3 focus:ring-0 focus:border-zinc-900 bg-transparent text-lg outline-none transition-colors placeholder:text-zinc-400"
                required
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
                Password
              </label>
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border-0 border-b border-zinc-200 rounded-none px-0 py-3 focus:ring-0 focus:border-zinc-900 bg-transparent text-lg outline-none transition-colors placeholder:text-zinc-400"
                required
              />
            </div>
          </div>

          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full bg-zinc-900 text-white rounded-none px-8 py-4 font-medium hover:bg-zinc-800 transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign in →"}
          </button>

          <div className="text-xs text-zinc-400 border-t border-zinc-100 pt-6">
            <span className="font-bold uppercase tracking-[0.2em] text-zinc-500">
              Demo
            </span>{" "}
            admin@invoiceapp.com / admin123
          </div>
        </form>
      </div>
    </div>
  );
}
